import { useSelector } from 'react-redux'

import { ApplicationState } from 'redux/Stores/types'

import {
  selectAllExportTables,
  selectExportTablesLoading,
  selectExportTableIncludeWidget
} from 'redux/selectors/ExportTables'

/**
 * Hook for getting all export tables as array
 * @returns array of export tables
 */
export const useExportTables = () => {
  return useSelector(selectAllExportTables)
}

/**
 * Hook for getting export tables loading states
 * @returns object with loading states
 */
export const useExportTablesLoading = () => {
  return useSelector(selectExportTablesLoading)
}

/**
 * Get a specific export table with resolved widget.
 * Returns export table with widget from WidgetStore.
 * @param id - Export table ID
 * @returns TExportTableWithWidget | null
 */
export const useExportTableIncludeWidget = (id: string | null) => {
  return useSelector((state: ApplicationState) =>
    selectExportTableIncludeWidget(state, id)
  )
}

/**
 * Hook for getting isCreating state for export tables
 * @returns boolean
 */
export const useIsCreatingExportTable = () => {
  const { isCreating } = useSelector(selectExportTablesLoading)

  return isCreating
}
